import { AbstractControl, FormControl, FormGroup } from "@angular/forms";
import { isEmpty } from "rxjs/operators";
import { VMSConstants } from '../constants/vms-constants';

export function EmailValidator(inputValue: string) : boolean {
    var res = new RegExp(VMSConstants.emailValidator);
   
    if (res.test(inputValue)) {
        return true;
    } else {
        return false;
    }
  }

  export function NameValidator(inputValue: string) : boolean {
    var res = new RegExp(VMSConstants.nameValidator);
    if (res.test(inputValue)) {
        return true;
    } else {
        return false;
    }
  }
  export function ApplicantNameValidator(inputValue: string) : boolean {
    var res = new RegExp(VMSConstants.applicantNameValidator);
    if (res.test(inputValue)) {
        return true;
    } else {
        return false;
    }
  }

  export function PhoneValidator(inputValue: string) : boolean {
    //string phoneExtValidator = /^[0-9]{3,6}$/;
    var res = new RegExp(/^[0-9]{10}$/);
    
    if (res.test(inputValue)) {
        //console.log(inputValue);
        return true;
    } else {
        return false;
    }
  }

  export function BillRateValidator(inputValue: string) : boolean {
    var res = new RegExp(/^((?!(0))[0-9]{1,3})(\.\d{0,2})?$/);
    if (res.test(inputValue)) {
        return true;
    } else {
        return false;
    }
  }

  export function ExperienceValidator(inputValue: string) : boolean {
    //var res = new RegExp(/^((?!(0))[0-9]{1,3})(\.\d{0,2})?$/);
    var res  = new RegExp(/^(\d{1,2})(\.([1-9]|1[0-1]))?$/);
    if (res.test(inputValue)) {
        return true;
    } else {
        return false;
    }
  }
  export function isNullValidator(inputValue: string) : boolean {
    
    if (typeof  inputValue!='undefined' && inputValue) {
        return false;
    } else {
        return true;
    }
  }

  export function isCompareDateValidator(fromDate: string, toDate: string) : boolean {
    
   
    const date1 = new Date(fromDate);
    const date2 = new Date(toDate);

    const date1WithoutTime = new Date(date1.getTime());
    const date2WithoutTime = new Date(date2.getTime());

    date1WithoutTime.setUTCHours(0, 0, 0, 0);
    date2WithoutTime.setUTCHours(0, 0, 0, 0);

    if (date1WithoutTime.getTime() === date2WithoutTime.getTime()) {
        return false;
    } else if (date1WithoutTime.getTime() > date2WithoutTime.getTime()) {
        return false;
    } else  {
        return true;
    }

  }

  export function emailWithWhitespaceValidator(control: FormControl) {
    const isValid = control.value
      .trim()
      .match('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$');
    return isValid ? null : { isValid: false };
  }